import CIMSTable from 'components/CIMSTable'
import { useDocumentChecklistsTableContext } from '../../DocumentChecklistsTableContext'
import { useColumns } from './hooks/useColumns'
import { useCreateOptions } from './hooks/useCreateOptions'
import { useEditOptions } from './hooks/useEditOptions'
import { useExpandOptions } from './hooks/useExpandOptions'
import { useRemoveOptions } from './hooks/useRemoveOptions'

export const DocumentChecklistsTable: React.FC = () => {
  const { records, refetch, fetching } = useDocumentChecklistsTableContext()

  const columns = useColumns()
  const createOptions = useCreateOptions()
  const editOptions = useEditOptions()
  const removeOptions = useRemoveOptions()
  const expand = useExpandOptions()

  return (
    <CIMSTable
      rowKey={'id'}
      loading={fetching}
      records={records}
      columns={columns}
      actions={{
        header: {
          create: createOptions,
          onReload: refetch,
        },
        row: { edit: editOptions, remove: removeOptions },
      }}
      expand={expand}
    />
  )
}
